import { render, staticRenderFns } from "./SingleLineText.vue?vue&type=template&id=55152c8e"
import script from "./SingleLineText.vue?vue&type=script&lang=js"
export * from "./SingleLineText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports